import React from 'react'
import "./Header.css"

function Header() {
    return (
        <div className="gridContainerHeader">
            <div className="left"><a href="#Hero">JazzySince1992.</a></div>
            <div className="right"> 
                <ul>
                    <li className="hero"><a href="#Hero">Home</a></li>
                    <li className="backGround"><a href="#Background">Back Ground</a></li>
                    <li className="skills"><a href="#Skills">Skills</a></li>
                    <li className="personalDetails"><a href="#PersonalDetails">Personal Details</a></li>
                </ul>

            </div>
        </div>
    )
}

export default Header
